import { DesignToken } from '@livechat/design-system-react-components'
import { URLS } from 'gatsby-theme-marketplace-base/src/constants'
import { withVar } from 'gatsby-theme-marketplace-base/src/utils/styles'
import type { ReactNode } from 'react'

export interface FeaturedCategory {
  label: string
  url: string
  image: string
  gradient?: string
  description: ReactNode
}

export const FEATURED_APP_CATEGORIES: FeaturedCategory[] = [
  {
    label: URLS.BY_TEXT.LABEL,
    url: URLS.BY_TEXT.LINK,
    image:
      'https://cdn.livechat-static.com/api/file/developers/img/default/assets/by-text-campaign.png',
    gradient: withVar(DesignToken.SurfaceGradient13),
    description:
      'Apps from the Text team designed to simplify your day-to-day tasks.',
  },
  {
    label: URLS.AI_POWERED.LABEL,
    url: URLS.AI_POWERED.LINK,
    image:
      'https://cdn.livechat-static.com/api/file/developers/img/default/assets/ai-powered-campaign.png',
    gradient: withVar(DesignToken.SurfaceGradient06),
    description:
      'Extend your LiveChat with AI apps that boost your customer service.',
  },
  {
    label: URLS.NEW_AND_NOTEWORTHY.LABEL,
    url: URLS.NEW_AND_NOTEWORTHY.LINK,
    image:
      'https://cdn.livechat-static.com/api/file/developers/img/default/assets/new-and-noteworthy-campaign.png',
    gradient: withVar(DesignToken.SurfaceGradient05),
    description:
      'Recently published, high-quality apps recognized by LiveChat experts.',
  },
  {
    label: URLS.STAFF_TOP_PICKS.LABEL,
    url: URLS.STAFF_TOP_PICKS.LINK,
    image:
      'https://cdn.livechat-static.com/api/file/developers/img/default/assets/staff-top-picks-campaign.png',
    gradient: 'linear-gradient(95.09deg, #D1F4D5 0%, #FAFEFB 110.26%)',
    description:
      'Feature-rich applications that greatly enhance your chatting experience.',
  },
]
